import { render, staticRenderFns } from "./soundSystems.vue?vue&type=template&id=0b464a76&"
import script from "./soundSystems.vue?vue&type=script&lang=js&"
export * from "./soundSystems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports